import { translate } from '@shakkerai/util-i18n';
import { getCurrentChoosedMenuState } from '../store/state';

export * from '@shakkerai/pro-models/src/constants';

export const defQuickAppMenuId = 1008;

export const modalType = {
  CHECKPOINT: 'checkpoint',
  LORA: 'lora',
  WORKFLOW: 'workflow',
};

export const modelTypeMap = {
  [modalType.CHECKPOINT]: '1',
  [modalType.LORA]: '5',
  [modalType.WORKFLOW]: '18',
};

export const defMenu = {
  presetModelId: 'preset-1000',
  collectModelId: 'collect-1002',
  historyModelId: 'history-1003',
  hotRecommendId: 'hot-1004',
  workflow: 'workflow',
};

// 收藏类型
export const collectOptions = [
  { value: 1, label: translate('model_sort_option_fav') },
  { value: 2, label: translate('model_sort_option_most_used') },
];

export const menuLevel = {
  L0: 0, // 第一层menu，报错收藏、最近使用、应用场景等
  L1: 1, // 应用场景等 具体分类下的一级分类
  L2: 2, // 二级分类 (二级分类是横向tag展示)
};

export const innerMoreType = {
  collect: 'collect',
  children: 'children',
};

export const checkpointDefMenu = [
  {
    id: defMenu.presetModelId,
    code: `${defMenu.presetModelId}`,
    tagLabel: translate('menu_label_preset'),
  },
  {
    id: defMenu.collectModelId,
    code: `${defMenu.collectModelId}`,
    tagLabel: translate('menu_label_favorite'),
  },
  {
    id: defMenu.historyModelId,
    code: `${defMenu.historyModelId}`,
    tagLabel: translate('menu_label_history'),
  },
];

export const loraDefMenu = [
  {
    id: defMenu.collectModelId,
    code: `${defMenu.collectModelId}`,
    tagLabel: translate('menu_label_favorite'),
  },
  {
    id: defMenu.historyModelId,
    code: `${defMenu.historyModelId}`,
    tagLabel: translate('menu_label_history'),
  },
  {
    id: defMenu.hotRecommendId,
    code: `${defMenu.hotRecommendId}`,
    tagLabel: translate('menu_label_hot'),
  },
];

// 预设还没上海外
export const workFlowMenu = [
  {
    id: defMenu.collectModelId,
    code: `${defMenu.collectModelId}`,
    tagLabel: '收藏',
  },
  {
    id: defMenu.historyModelId,
    code: `${defMenu.historyModelId}`,
    tagLabel: '最近使用',
  },
  {
    id: '1008',
    tagLabel: '精选推荐',
    code: 1008,
  },
  {
    id: '1009',
    tagLabel: '热点趣图',
    code: 1009,
  },
  {
    id: '1010',
    tagLabel: '风格转换',
    code: 1010,
  },
  {
    id: '1011',
    tagLabel: '实用工具',
    code: 1011,
  },
  {
    id: '1012',
    tagLabel: '人像摄影',
    code: 1012,
  },
  {
    id: '1013',
    tagLabel: '电商应用',
    code: 1013,
  },
  {
    id: '1014',
    tagLabel: '建筑设计',
    code: 1014,
  },
  {
    id: '1015',
    tagLabel: '角色设计',
    code: 1015,
  },
  {
    id: '1016',
    tagLabel: '玩具手办',
    code: 1016,
  },
  {
    id: '1017',
    tagLabel: '视频',
    code: 1017,
  },
];

export const FORMAT_SELECT_STATE = 'FORMAT_SELECT_STATE';

const checkoutDefMenuId = 200000; // 业务上的动态数据
const loraDefMenuId = 200000; // 业务上的动态数据
const workflowDefMenuId = defQuickAppMenuId;

export const getWhoIsDefOpendMenu = (type) => {
  if (type === modalType.CHECKPOINT) {
    return checkoutDefMenuId;
  } else if (type === modalType.LORA) {
    return loraDefMenuId;
  } else {
    return workflowDefMenuId;
  }
};
// 菜单是否被选中
export const isMenuChoosed = (type, id) => {
  const currentMenuId = getCurrentChoosedMenuState(type);
  if (currentMenuId) return id === currentMenuId;
  return id + '' === getWhoIsDefOpendMenu(type) + '';
};

// 菜单是否展开（根据12级菜单的选中状态）
export const isMenuOpened = (type, menu) => {
  const currentMenuId = getCurrentChoosedMenuState(type);
  if (currentMenuId) {
    return menu.id === currentMenuId || (menu.children ?? []).some((child) => child.id === currentMenuId);
  }
  return menu.id === getWhoIsDefOpendMenu(type);
};

// 被选中菜单的id（用于页面初始化）
export const currentChoosedMenuId = (type) => {
  const currentMenuId = getCurrentChoosedMenuState(type);
  if (currentMenuId) return currentMenuId;
  return getWhoIsDefOpendMenu(type);
};

export const quickModelShowType = {
  collection: 1, // 合集快捷展示
  tagCode: 2, // tagCode快捷展示，一般是3级分类模型
  appendTagCode: 3, // 追加的tagCode, 用于无限滚动
};

export const hotModelsList = [
  {
    type: quickModelShowType.collection,
    label: '新年氛围不能输',
    code: 1002,
  },
  {
    type: quickModelShowType.collection,
    label: '超现实主义',
    code: 1004,
  },
  {
    type: quickModelShowType.collection,
    label: '星流独家',
    code: 1005,
  },
  {
    type: quickModelShowType.collection,
    label: '幻想绘本',
    code: 1006,
  },
  {
    type: quickModelShowType.collection,
    label: '中式非遗',
    code: 1007,
  },
];

export const hotQuickAppList = [
  {
    type: quickModelShowType.collection,
    label: '精选推荐',
    code: defQuickAppMenuId,
  },
];
